import { render, staticRenderFns } from "./descConfig.vue?vue&type=template&id=73ba98ee&scoped=true"
import script from "./descConfig.vue?vue&type=script&lang=ts"
export * from "./descConfig.vue?vue&type=script&lang=ts"
import style0 from "./descConfig.vue?vue&type=style&index=0&id=73ba98ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba98ee",
  null
  
)

export default component.exports